export default __webpack_public_path__ + "static/terms_of_service.pdf?4bd9a8e19cc6";